import { PATH } from '@/shared/constants';
import { CardBackgroundColorType } from '@/shared/types';

export const cardBackgroundColor: Record<CardBackgroundColorType, string> = {
  primary: 'bg-primary-200',
  purple: 'bg-[#9D98F7]',
  skyblue: 'bg-[#94C3FF]',
};

const commonGuestProps = {
  buttonText: '회원가입',
  buttonLink: PATH.AUTH_SIGNUP,
};

export const attentionGrabCardProps = {
  guest: {
    description: {
      prefix: '요즘IT 멤버가 되어',
      highlight: '\n형광펜',
      suffix: ' 해보세요.',
    },
    buttonText: '회원가입',
    buttonLink: `${PATH.AUTH_SIGNUP}`,
  },
  member: {
    description: {
      prefix: '성장을 위한 한 줄,',
      highlight: '\n형광펜',
      suffix: ' 해보세요.',
    },
    buttonText: '내 컬렉션 바로가기',
    buttonLink: PATH.MY_COLLECTION_HIGHLIGHT,
  },
};

export const cardLeftPaddingStyle = 'pl-4 tablet:pl-6';
